// extracted by mini-css-extract-plugin
export default {"active":"Settings__active___uwRd4","settings":"Settings__settings___zR_Z_","iconPlaceholder":"Settings__iconPlaceholder___cL3AH"};